export default __webpack_public_path__ + "static/media/logo--mobile.4abe0e3e.svg";